const isDeviceMobile = () => {
	return window.screen.width < 500 ? true : false;
};
export default isDeviceMobile;
